import { render, staticRenderFns } from "./TextUploadModal.vue?vue&type=template&id=7add4944&scoped=true&"
import script from "./TextUploadModal.vue?vue&type=script&lang=js&"
export * from "./TextUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./TextUploadModal.vue?vue&type=style&index=0&id=7add4944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add4944",
  null
  
)

export default component.exports